import {z} from 'zod'

import {exerciseTypes} from '#/themes/classic-quiz/exerciseTypes'
import {type ThemePlugin} from '#/types/capsule'
import {HtmlBridgeEditor} from './HtmlBridgeEditor'
import {HtmlBridgePlayer} from './HtmlBridgePlayer'

const htmlBridgeTheme: ThemePlugin = {
  id: 'html-bridge',
  name: 'HTML Bridge',
  version: '1.0.0',
  description:
    "Charger n'importe quel thème HTML/CSS/JS via le protocole postMessage",
  previewColor: '#14b8a6',
  category: 'custom' as const,
  exerciseTypes,
  settingsSchema: z.object({
    htmlThemeUrl: z.string().url().optional(),
    customHtml: z.string().optional(),
    customHtmlFileName: z.string().optional(),
    instantFeedback: z.boolean().default(true),
    showProgressBar: z.boolean().default(true),
    shuffleOptions: z.boolean().default(false),
  }),
  PlayerComponent: HtmlBridgePlayer,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  EditorComponent: HtmlBridgeEditor as any,
  PreviewComponent: HtmlBridgePlayer,
}

export default htmlBridgeTheme
